<template lang="html">
  <div class="registerBox">
    <div class="close-btn" @click="goLogin">×</div>
    <div class="title-a">注册账号</div>
    <a-input size="large" v-model="phone" placeholder="请输入手机号" style="width:80%;margin-bottom:30px;" />
    <a-input size="large" v-model="username" placeholder="请输入昵称" style="width:80%;margin-bottom:30px;" />
    <a-input-password size="large" v-model="password" placeholder="请输入密码" style="width:80%;margin-bottom:30px;" />
    <a-input-password size="large" v-model="confirmPassword" placeholder="重复密码" style="width:80%;" />
    <a-button type="primary" style="width:80%;margin-top:20px;" @click="registerBtn">注册</a-button>
    <div class="register" @click="goLogin">
      <span style="color:#CCC;">已有账号？</span>请登录
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      isShow: false,
      phone: '',
      username: '',
      password: '',
      confirmPassword: ''
    }
  },
  methods:{
    registerBtn(){
      // 表单验证
      if (!this.phone || !this.username || !this.password || !this.confirmPassword) {
        this.$notification['error']({
          message: '提示',
          description: '请填写完整信息'
        });
        return;
      }

      // 验证手机号格式
      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        this.$notification['error']({
          message: '提示',
          description: '请输入正确的手机号'
        });
        return;
      }

      // 验证密码
      if (this.password !== this.confirmPassword) {
        this.$notification['error']({
          message: '提示',
          description: '两次输入的密码不一致'
        });
        return;
      }

      // 从 localStorage 获取用户列表
      const users = JSON.parse(localStorage.getItem('users') || '[]');
      
      // 检查用户名是否已存在
      if (users.some(user => user.username === this.username)) {
        this.$notification['error']({
          message: '提示',
          description: '该用户名已被注册'
        });
        return;
      }

      // 检查手机号是否已存在
      if (users.some(user => user.phone === this.phone)) {
        this.$notification['error']({
          message: '提示',
          description: '该手机号已被注册'
        });
        return;
      }

      // 添加新用户
      users.push({
        phone: this.phone,
        username: this.username,
        password: this.password
      });

      // 保存到 localStorage
      localStorage.setItem('users', JSON.stringify(users));

      // 显示成功提示
      this.$notification['success']({
        message: '注册成功',
        description: '请登录您的账号',
        duration: 2
      });

      // 清空表单
      this.phone = '';
      this.username = '';
      this.password = '';
      this.confirmPassword = '';

      // 跳转到登录页
      this.goLogin();
    },
    goLogin(){
      this.$emit('goLogin', this.isShow)
    }
  }
}
</script>

<style lang="scss" scoped>
  .registerBox{
    width: 550px;
    height: 520px;
    background: #fff;
    position: fixed;
    box-shadow: 0 0 20px 0 rgba(0,0,0,0.08);
    top: 13.7%;
    left: 34.4%;
    z-index: 101;
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    padding: 30px;
    position: relative;
    .close-btn {
      position: absolute;
      right: 20px;
      top: 20px;
      font-size: 24px;
      color: #999;
      cursor: pointer;
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      &:hover {
        color: #666;
      }
    }
    .title-a{
      font-size: 24px;
      color: #666666;
      margin-bottom: 30px;
    }
    .register{
      width: 80%;
      text-align: right;
      color: #1890ff;
      margin-top:30px;
      cursor: pointer;
    }
  }
</style>
